<template>
  <div id="map"></div>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.locatecontrol";

var $ = require("jquery");

import { mapState, mapMutations } from "vuex";

import GeodirLayerAdmin from "../assets/js/managerMap/layer-layout";
require("../assets/js/control/L.GeodirLegend.js");
require("leaflet-contextmenu");

import axios from "axios";

export default {
  components: {},
  data: function () {
    return {
      map: null,
      locate: "",
      access_token: "",
    };
  },

  computed: {
    ...mapState(["latitud_general", "longitud_general", "place_id"]),
  },

  created() {
    this.access_token = process.env.VUE_APP_TOKEN_APIS;
  },

  mounted() {
    let app = this;

    //validar sesion
    if (app.checkLogin()) {
      const tokenData = JSON.parse(window.localStorage.getItem("geodir_Token"));
      app.access_token = tokenData.data.access_token;
    }
    this.$store.watch(this.$store.getters.isLoggedIn, (n) => {
      if (!n) {
        app.access_token = process.env.VUE_APP_TOKEN_APIS;
      }
    });

    this.initMap();

    //let isGeolocationActivate = await this.geolocationIsActivate();
    /*this.geolocationIsActivate().then( (result) => {
		console.warn('geolocalizacion');
		console.log(result)
	if (result) {
		this.activateGeolocation();
	} 
	}

	)*/

    console.warn("geolocalizacion");

    let self = this;
    navigator.permissions.query({ name: "geolocation" }).then((result) => {
      console.log(result);
      if (result.state == "denied") {
        console.log("geolocalizacion es denegada");
      } else {
        console.log("geolocalizacion es aceptada");
        self.activateGeolocation();
        self.stopFollowingGeolocation();
      }
    });

    //this.stopFollowingGeolocation();

    this.initManagers();

    console.log("RUTAS");
    console.log(this.$route.path);
    console.log(this.$route.params);
    console.log(this.$route.params.placeId);
    this.searchPlaceId();
  },
  methods: {
    ...mapMutations(["store_setMap"]),

    checkLogin() {
      return this.$store.state.isLoggedIn;
    },

    searchPlaceId() {
      var self = this;
      let placeId = this.$route.params.placeId;
      console.log("buscar");
      console.log(placeId);
      if (placeId) {
        /*let urlPlaceDetail =
          process.env.VUE_APP_PLACES_DETAILS +
					`place_id=${placeId}&key=${this.access_token}`;*/

        let urlPlaceDetail =
          "https://apis.geodir.co/places/fields/v1/json?" +
          `place_id=${placeId}&key=b5abb242-39a3-4179-a6c3-8eaf4269ea85`;

        axios
          .get(urlPlaceDetail)
          .then(function (response) {
            console.log("Se obtuvo el detail correctamente");
            console.log(response);

            self.resultPlaceDetail(response.data);
          })
          .catch(function (error) {
            console.error(error);
          });
      }
    },

    resultPlaceDetail(result) {
      console.log("resultados del place");

      let self = this;
      if (result.status == "OK") {
        console.log("resultado ok");
        var customIcon = new L.Icon({
          iconUrl: require("../assets/images/icon_marker.png"),
          iconAnchor: [12, 2],
        });

        let coordinates = result.geometry.coordinates;

        self.$store.commit("SET_LATITUD_GENERAL", coordinates.lat);
        self.$store.commit("SET_LONGITUD_GENERAL", coordinates.lon);

        let place_id = result.place_id;
        this.$store.commit("SET_PLACE_ID", place_id);

        let address = result.standard_address;
        this.$store.commit("SET_ADDRESS", address);

        var latlng = L.GeoJSON.coordsToLatLng([
          coordinates.lon,
          coordinates.lat,
        ]);

        self.map.setView(latlng, 18, {
          duration: 1,
        });

        var marker = L.marker(latlng, { icon: customIcon })
          .addTo(self.map)
          .bindPopup(result.standard_address)
          .openPopup();

        this.$store.commit("SET_LAYER_MARKER", marker);
      }
    },

    geolocationIsActivate() {
      // check for Geolocation support
      if (navigator.geolocation) {
        console.log("Geolocation is supported!");
      } else {
        console.log("Geolocation is not supported for this Browser/OS.");
      }

      if ("geolocation" in navigator) {
        console.log("geolocalizacion habilitada");
        return true;
      }
    },

    activateGeolocation() {
      console.log("activar localizacion");
      this.locate.start();
    },

    stopFollowingGeolocation() {
      let self = this;
      this.map.on("locationfound", function () {
        console.log("parar seguimiento");
        self.locate.stopFollowing();
      });
    },

    initMap() {
      console.log("iniciar mapa");

      L.Marker.prototype.options.icon = L.icon({
        iconUrl: require("@/assets/images/icon_marker.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
        iconSize: [25, 35],
        iconAnchor: [13, 35],
        popupAnchor: [-13, -30],
      });

      this.map = L.map("map", {
        center: [-12.13181, -76.989698],
        zoom: 13,
        minZoom: 1,
        maxZoom: 20,
        scaleControl: false,
        attributionControl: false,
        zoomControl: false,
        contextmenu: true,
      });

      const geodirStreets = L.tileLayer(
        "https://tiles.geodir.co/osm_tiles/{z}/{x}/{y}.png",
        {
          minZoom: 1,
          maxZoom: 20,
          attribution:
            '&copy; <a href="https://inkamaps.com/" target="_blank">Inkamaps</a> contributors',
        }
      ).addTo(this.map);

      const geodirSatellite = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
        {
          minZoom: 1,
          maxZoom: 20,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        }
      );

      const baseMaps = {
        "Geodir Calles": geodirStreets,
        "Geodir Satélite": geodirSatellite,
      };

      const scale = L.control
        .scale({
          imperial: false,
        })
        .addTo(this.map);

      const attribution = L.control
        .attribution({
          prefix: "",
        })
        .addTo(this.map);

      const zoom = L.control
        .zoom({
          position: "bottomright",
          zoomInTitle: "Acercar",
          zoomOutTitle: "Alejar",
        })
        .addTo(this.map);

      const layers = L.control
        .layers(baseMaps, null, {
          position: "bottomright",
        })
        .addTo(this.map);

      this.locate = L.control
        .locate({
          position: "bottomright",
          flyTo: true,
          keepCurrentZoomLevel: true,
          icon: "geodir-icon-location",
          drawCircle: false,
          markerStyle: {
            color: "#fff",
            fillColor: "#115cd8",
            radius: 8,
            fillOpacity: 1,
            weight: 2.5,
          },
          strings: {
            title: "Tú ubicación",
          },
          showPopup: false,
        })
        .addTo(this.map);

      var legend = L.geodirLegend({
        url_layers: "http://builder.geodir.co/sql-api/geodir/ext/layer/json",
      }).addTo(this.map);

      let separator = {
        separator: true,
        index: 10,
      };

      this.map.contextmenu.addItem(separator);

      const that = this;

      let centerMap = {
        text: "Centrar mapa",
        callback: function (e) {
          that.map.panTo(e.latlng);
        },
        index: 12,
      };

      if (this.$route.params.tipo == "map") {
        let latlng = new L.latLng(this.$route.params.y, this.$route.params.x);
        this.map.setView(latlng, this.$route.params.z);
      }

      /*this.map.on('mouseup zoomend', function() {
			if (that.$route.params.tipo == null || that.$route.params.tipo == 'map') {

				console.log('asignar route');

				let actualRoute = that.$route.fullPath;

				that.$router.push({path: `${actualRoute}/map/${y}/${x}/${z}` });

			}
		});*/

      this.map.contextmenu.addItem(centerMap);

      this.store_setMap(this.map);
    },

    initManagers() {
      var instanceGeodirLayerAdmin = GeodirLayerAdmin.getInstance("");
      instanceGeodirLayerAdmin.setMap(this.map);
    },
  },
};
</script>

<style>
#map {
  width: 100%;
  height: 100%;
}

.leaflet-contextmenu {
  z-index: 10000;
  position: absolute;
  left: 885px;
  right: auto;
  top: 123px;
  bottom: auto;
  display: none;
  box-shadow: 0 1px 7px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
  padding: 4px 0;
  background-color: #fff;
  cursor: default;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: left;
}

.leaflet-contextmenu a.leaflet-contextmenu-item {
  display: block;
  color: #222;
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;
  padding: 0 12px;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  cursor: default;
  outline: none;
}

.leaflet-contextmenu a.leaflet-contextmenu-item {
  font-size: 15px !important;
  padding: 5px 20px !important;
}

.leaflet-contextmenu-icon {
  width: 18px;
  margin: 0px 8px 0px 0px;
}

.leaflet-control-layers-toggle {
  width: 30px !important;
  height: 30px !important;
}
</style>

